import React, { useState } from 'react';
import { translate } from '../translations/translations.js';

const POITypeForm = ({formData, language, onNavigate}) => {
  const [history, setHistory] = useState(3);
  const [nature, setNature] = useState(3);
  const [art, setArt] = useState(3);
  const [culture, setCulture] = useState(3);
  const [leisure, setLeisure] = useState(3);
  const info = [0, translate('interest1', language), 
                    translate('interest2', language), 
                    translate('interest3', language), 
                    translate('interest4', language), 
                    translate('interest5', language)]
  
  const handleHistoryChange = (event) => {
    setHistory(event.target.value);
  };

  console.log(formData)

  const handleNatureChange = (event) => {
    setNature(event.target.value);
  };

  const handleArtChange = (event) => {
    setArt(event.target.value);
  };

  const handleCultureChange = (event) => {
    setCulture(event.target.value);
  };

  const handleLeisureChange = (event) => {
    setLeisure(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const newData = {
      ...formData,
      user_history: history,
      user_nature: nature,
      user_art: art,
      user_culture: culture,
      user_leisure: leisure
    };
    onNavigate(newData);
  };

  
  return (
      <form onSubmit={handleSubmit}>
        <header className='form-header'>
          <h1>{translate('POITypePrompt', language)}</h1>
        </header>
        <div className="form-container">
          <div className='input-POItype'>
              <label className='date-label'>{translate('history', language)}:</label>
              <input
              type="range"
              class="slider"
              min="1"
              max="5"
              value={history}
              onChange={handleHistoryChange}
              />
              <span className='slider-info'> {info[history].replace("X", translate('historyX', language))}</span>
          </div>
          <div className='input-POItype'>
              <label className='date-label'>{translate('nature', language)}:</label>
              <input
              type="range"
              class="slider"
              min="1"
              max="5"
              value={nature}
              onChange={handleNatureChange}
              />
              <span className='slider-info'> {info[nature].replace("X", translate('natureX', language))}</span>
          </div>
          <div className='input-POItype'>
              <label className='date-label'>{translate('art', language)}:</label>
              <input
              type="range"
              class="slider"
              min="1"
              max="5"
              value={art}
              onChange={handleArtChange}
              />
              <span className='slider-info'> {info[art].replace("X", translate('artX', language))}</span>
          </div>
          <div className='input-POItype'>
              <label className='date-label'>{translate('culture', language)}:</label>
              <input
              type="range"
              class="slider"
              min="1"
              max="5"
              value={culture}
              onChange={handleCultureChange}
              />
              <span className='slider-info'> {info[culture].replace("X", translate('cultureX', language))}</span>
          </div>
          <div className='input-POItype'>
              <label className='date-label'>{translate('leisure', language)}:</label>
              <input
              type="range"
              class="slider"
              min="1"
              max="5"
              value={leisure}
              onChange={handleLeisureChange}
              />
              <span className='slider-info'> {info[leisure].replace("X", translate('leisureX', language))}</span>
          </div>
        </div>
        <button type="submit" >{translate('submit', language)}</button>
      </form>
  );
};

export default POITypeForm;
